export const STYLE_PRESETS = {
  PROFESSIONAL: {
    name: "Professional",
    description: "Clean and formal",
    config: {
      header: "h2",
      bulletStyle: "•",
      spacing: "single",
      casing: "sentence",
    },
  },
  CASUAL: {
    name: "Casual",
    description: "Friendly and approachable",
    config: {
      header: "h3",
      bulletStyle: "emoji",
      spacing: "double",
      casing: "normal",
    },
  },
  ANNOUNCEMENT: {
    name: "Announcement",
    description: "Bold and attention-grabbing",
    config: {
      header: "h1",
      bulletStyle: "✨",
      spacing: "double",
      casing: "upper",
    },
  },
} as const;

export type StylePresetKey = keyof typeof STYLE_PRESETS;
export type StylePreset = typeof STYLE_PRESETS[StylePresetKey];
